<template>
    <div class="view view-challenge-leaderboard">
        <HeaderChallengeLeaderboard
            v-if="showHeader"
            :week="this.$store.state.response.challengeLeaderboard.leaderboardItems.week" />
        <Preloader
            v-if="showPreloader"
            preloaderText="Yükleniyor..." />
        <div
            v-if="showTop3"
            class="view-challenge-leaderboard__wr-list-top3">
            <CardChallengeLeaderboardFlank
                :leaderboardItem="top3List[1]" />
            <CardChallengeLeaderboardFirst
                :leaderboardItem="top3List[0]" />
            <CardChallengeLeaderboardFlank
                :leaderboardItem="top3List[2]" />
        </div>

        <div
            v-if="showRemainingList"
            class="view-challenge-leaderboard__wr-list-remaining">
            <ChallengeLeaderboardListItem
                v-for="leaderboardItem in remainingList" :key="leaderboardItem.id"
                :leaderboardItem="leaderboardItem" />
            <ChallengeLeaderboardListItem
                v-if="showCurrentUser"
                :leaderboardItem="currentUser" />
        </div>

        <Navbar />
        <BtnChallenge />
        <BtnPracticeModes />
    </div>
</template>
<script>
    import HeaderChallengeLeaderboard from '@/components/HeaderChallengeLeaderboard';
    import Preloader from '@/components/Preloader.vue';
    import CardChallengeLeaderboardFlank from '@/components/CardChallengeLeaderboardFlank.vue';
    import CardChallengeLeaderboardFirst from '@/components/CardChallengeLeaderboardFirst.vue';
    import ChallengeLeaderboardListItem from '@/components/ChallengeLeaderboardListItem.vue';
    import Navbar           from '@/components/Navbar.vue';
    import BtnChallenge     from '@/components/BtnChallenge.vue';
    import BtnPracticeModes from '@/components/BtnPracticeModes.vue';

    export default {
        components: {
            HeaderChallengeLeaderboard,
            Preloader,
            CardChallengeLeaderboardFlank,
            CardChallengeLeaderboardFirst,
            ChallengeLeaderboardListItem,
            Navbar,
            BtnChallenge,
            BtnPracticeModes,
        },

        data(){
            return {
                showPreloader: true,
            };
        },

        computed: {
            showHeader(){
                if(this.showPreloader){
                    return false;
                }
                return true;
            },

            showTop3(){
                if(this.showPreloader){
                    return false;
                }
                return true;
            },

            showCurrentUser(){
                return this.currentUser.rank > 10;
            },

            showRemainingList(){
                if(this.showPreloader){
                    return false;
                }
                return true;
            },

            top3List(){
                let leaderboardList = this.$store.state.response.challengeLeaderboard.leaderboardItems;
                return leaderboardList.top10.filter(item => item.rank <= 3);
            },

            remainingList(){
                let leaderboardList = this.$store.state.response.challengeLeaderboard.leaderboardItems;
                return leaderboardList.top10.filter(item => item.rank > 3);
            },

            currentUser(){
                return this.$store.state.response.challengeLeaderboard.leaderboardItems
                       ? this.$store.state.response.challengeLeaderboard.leaderboardItems.currentUser
                       : undefined;
            }
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.challengeLeaderboard)
                .then(response => response.json())
                .then(leaderboardItems => {
                    this.$store.commit('setResponseChallengeLeaderboardLeaderboardItems', leaderboardItems);
                    this.showPreloader = false;
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.challengeLeaderboard, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(leaderboardItems => {
                    this.$store.commit('setResponseChallengeLeaderboardLeaderboardItems', leaderboardItems);
                    this.showPreloader = false;
                })
                .catch(err => {
                    if(err.code === 'CHALLENGE_LEADERBOARD_MODEL/LEADERBOARD::INV_USER_SESSION'){
                        this.$foneturkError({
                            text: this.$t(`error.api.challengeLeaderboard.${err.code}`),
                            didClose: () => {
                                // this.$router.push('/login');
                            }
                        });
                    }
                    else{
                        this.$foneturkError({
                            text: this.$t(`error.default`),
                        });
                    }
                });
            }
        }
    };
</script>
<style scoped src="@/css/views/view-challenge-leaderboard.css"></style>